import { useRecoilValue } from "recoil";
import { jobsAtom } from "../miscellaneous/jobsAtom";

export const useJobsValue = () => {
  const jobs = useRecoilValue(jobsAtom);

  return jobs;
};
